@if (!utilService.isMobile() && this['data']==undefined) {
  <div class="page-title-container d-flex">
    <div class="page-title flex-grow-1 ">
      <div class="mb-0 ">
        <div class="d-flex align-items-center">
          <div class="pl-2 pr-2 ">
            <a class="d-inline-flex" href="javascript:void(0)" (click)="listResource()">
              <img src="assets/images/grid-back.png"></a>
            </div>
            <div class="">{{baseService._currentTitle | translate | async }} </div>
          </div>
        </div>
      </div>
      <div class="component-container "></div>
    </div>
  }
  <div class="layout_simple layout_simple_{{resourceDef != undefined && resourceDef.resource != undefined ? resourceDef.resource : ''}}">
    @if (fields) {
      <dhs-form [action]="'ADD'" [fieldGroup]="fields" [decorator]="decorator" [formtype]="this[data]==undefined?'':'popup'" [data]="currentData" [config]="config" (saveFinished)="onSaveFinished($event)" [customButton]='btn'>
      </dhs-form>
    }
  </div>
